<template>
    <el-container>
        <fhead></fhead>
        <el-main >
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.blocks.title')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{$t('l.block')}}</span>
                </div>
                <el-table class="center"
                          v-loading="BlocksLoading"
                          stripe
                          :data="BlocksData"
                          style="width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-table
                                    :data="scope.row.transactions"
                                    border
                                    style="width: 100%">
                                <el-table-column
                                        :label="$t('l.senderRS')"
                                        width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.senderRS">
                                            <el-button type="text"> {{scope.row.senderRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        :label="$t('l.recipientRS')"
                                        width="360">
                                    <template slot-scope="scope">
                                        <router-link :to="'/account/'+scope.row.recipientRS">
                                            <el-button type="text"> {{scope.row.recipientRS}}</el-button>
                                        </router-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        :label="$t('l.amountNQT')"
                                        width="180">
                                    <template slot-scope="scope">
                                        {{$g.wallet.amount(scope.row.amountNQT)}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        :label="$t('l.feeNQT')">
                                    <template slot-scope="scope">
                                        {{$g.wallet.amount(scope.row.feeNQT)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.height')"
                            width="140">
                        <template  slot-scope="scope">
                            <router-link :to="'/block/'+scope.row.height">
                                <el-button type="text"> {{scope.row.height}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="block"
                            :label="$t('l.block')+'id'"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.blocks.date')"
                            width="180">
                        <template slot-scope="scope">
                            {{$g.wallet.formatDateTime(scope.row.timestamp,($store.state.epochBeginning-500))}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.blocks.totalAmountNQT')"
                            width="180">
                        <template slot-scope="scope">
                            {{$g.wallet.amount(scope.row.totalAmountNQT)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('l.feeNQT')"
                            width="120">
                        <template slot-scope="scope">
                            {{$g.wallet.amount(scope.row.totalFeeNQT)}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="transactions.length"
                            :label="$t('l.transactionsLength')"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="generatorRS"
                            :label="$t('l.generatorRS')"
                            width="360">
                        <template slot-scope="scope">
                            <router-link :to="'/account/'+scope.row.generatorRS">
                                <el-button type="text"> {{scope.row.generatorRS}}</el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="text-align: center;"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="14"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    var load;
    var loadBlocks;
    var currentPage=1;
    import fhead from '../fhead.vue';
    export default {
        name: 'blocks',
        components: {
            fhead
        },
        data () {
            return {
                BlocksLoading:true,
                BlocksData:[],
                currentPage:1,
                total:0
            }
        },
        methods: {
            Transactions(item){
                if(item.transactions.length!=0&&!item.transactions[0].amountNQT){
                    this.$ajax({
                        method: 'get',
                        url: 'requestType=getBlock&height='+item.height+'&includeTransactions=true&includeExecutedPhased=true'
                    }).then(response => {
                        item.transactions=response.transactions
                        item.transactions.forEach(item=>{
                            item=this.$g.wallet.transactions(item,this.$store.state.apiText)
                            
                        })
                    });
                }
            },
            handleCurrentChange(val) {
               this.currentPage=val;
               currentPage=val;
               this.Blocks(1);
            },
            Blocks(state){
                this.BlocksLoading=true;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getBlocks&includeTransactions=true&firstIndex='+(this.currentPage-1)*14+'&lastIndex='+((this.currentPage-1)*14+14),
                }).then(response => {
                    this.BlocksLoading=false;
                    if(this.currentPage==1){
                        this.total=response.blocks[0].height

                    }
                    if(this.currentPage==1&&state==0){
                        if(this.BlocksData.length!=0&&
                            this.BlocksData[0].height!=response.blocks[0].height){
                            response.blocks[0]=this.$g.wallet.blocks(response.blocks[0],this.$store.state.apiText)
                            this.BlocksData.unshift(response.blocks[0]);
                            this.Transactions(this.BlocksData[0]);
                            this.BlocksData.pop();
                        }
                    }
                    if(this.BlocksData.length==0||state==1){
                        this.BlocksData=response.blocks;
                        this.BlocksData.forEach(item=>{
                            item=this.$g.wallet.blocks(item,this.$store.state.apiText)
                            this.Transactions(item);
                        })
                    }
                });
            }
        },
        created: function () {
            load =setInterval(()=>{
                if(this.$store.state.epochBeginning!=''){
                    this.Blocks();
                    loadBlocks=setInterval(()=>{
                        if(currentPage==1) {
                            this.Blocks(0);
                        }
                    },6000)
                    window.clearInterval(load)
                }
            },2000);

        },
        beforeDestroy: function () {
            window.clearInterval(load)
            window.clearInterval(loadBlocks)

        }
    }
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/block/blocks.vue